import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import UpdateIcon from "@material-ui/icons/Update";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import NumberFormatCustom from "../numberFormat";
import PriceFormat from "../../partials/priceFormat";
import Snackbar from "../../components/snackbar";
import { styles } from "./style";
import SalaryEmployee from "../cost/salaryEmployee";
import ConfirmUpdateSalary from "../cost/confirmUpdateSalary";
import Dialog from "../dialog";
class ListCost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newCostName: "",
      newCostValue: 0,
      flagEdit: false, // trạng thái chỉnh sửa của người dùng
      nameEdit: null,
      isAddNew: false,
      rows: [],
      tyleList: this.props.tyleList,
      ListEmployeeSalary: [],
      totalSalary: 0,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      isAddSalary: true,
      typeDialog: "",
      itemDelete: ""
    };
    this.t = this.props.t;
  }

  async componentDidMount() {
    this.props.onRef(this);
    if (this.state.tyleList === "cost") {
      this.getListEmployeeSalary(this.state.month, this.state.year);
    }
  }
  checkEdit = () => {
    return this.state.flagEdit;
  };
  handleOpenSalary = ListEmployeeSalary => {
    if (ListEmployeeSalary) this.SalaryEmployee.show(ListEmployeeSalary);
  };
  changeState = ojb => {
    this.setState({
      ...ojb,
      flagEdit: false,
      nameEdit: ""
    });
    if (this.state.tyleList === "cost") {
      this.getListEmployeeSalary(ojb.month, ojb.year);
    } else {
      this.setState({ ListEmployeeSalary: [], totalSalary: 0 });
    }
  };
  checkTime = (month, year) => {
    // kiểm tra tháng năm là quá khứ hay hiện tại và tương lai, nếu là qk trả về false
    let monthCurrent = new Date().getMonth() + 1;
    let yearCurrent = new Date().getFullYear();
    if (year < yearCurrent || (year === yearCurrent && month < monthCurrent))
      return false;
    // else if ((year === yearCurrent) && (month < monthCurrent)) return false
    else return true;
  };
  getListEmployeeSalary = async (month, year) => {
    if (month && year && this.checkTime(month, year)) {
      let check = await this.props.getListEmployeeSalary({
        month: month,
        year: year
      });
      if (check.code === 1 && check.data.length) {
        let totalSalary = 0;
        check.data.forEach(employee => {
          totalSalary += employee.bonusTotal;
          totalSalary += employee.salary;
        });
        this.setState({
          ListEmployeeSalary: check.data,
          totalSalary: totalSalary
        });
      }
    } else this.setState({ ListEmployeeSalary: [], totalSalary: 0 });
  };
  handleDeleteCost = item => {
    let check = false;
    let rows = this.state.rows;
    rows.map((row, index) => {
      if (row.name === item.name) check = index;
    });
    if (check) rows.splice(check, 1);
    else {
      this.mSnackbar.handleClick(check.message);
    }
    let checkExist = rows.filter(ele => ele.name === "employee_salary");
    this.props.handleSaveChange({
      rows: rows,
      salaryEmployee: !checkExist.length ? this.state.ListEmployeeSalary : "",
      totalSalary: this.state.totalSalary
    });
    // this.setState(rows)
  };
  addNewCost = status => {
    this.changeState({ isAddNew: status });
  };
  handleAddNewCost = () => {
    if (!this.state.newCostName)
      this.mSnackbar.handleClick(
        this.t("service_table_cost_please_fill_in_cost_name"),
        "warning"
      );
    else if (this.state.newCostName === "employee_salary")
      this.mSnackbar.handleClick(
        this.t("service_table_cost_name_is_already_in_use"),
        "warning"
      );
    else {
      let rows = this.state.rows;
      rows.push({
        isSystem: 0,
        name: this.state.newCostName,
        value: this.state.newCostValue || 0
      });
      let checkExist = rows.filter(ele => ele.name === "employee_salary");
      this.props.handleSaveChange({
        rows: rows,
        salaryEmployee: !checkExist.length ? this.state.ListEmployeeSalary : "",
        totalSalary: this.state.totalSalary
      });
      this.setState({ isAddNew: false, newCostName: "", newCostValue: 0 });
    }
  };
  handleRowNewChange(name, value) {
    this.setState({
      [name]: value
    });
  }
  handleRowEditChange(type, name, value) {
    let check = -1;
    this.state.rows.map((row, index) => {
      if (row.name === name) check = index;
    });
    if (check !== -1) {
      let rows = this.state.rows;
      if (type === "costValue") rows[check].value = value;
      else rows[check].name = value;
      this.setState({
        rows,
        flagEdit: true
      });
    }
  }
  handleEditComponent = (item, id) => {
    let state = this.state;
    state.nameEdit = item.name;
    // state.flagEdit = true
    state.isAddNew = false;
    this.setState(state);
  };
  // handleDeleteSalary = () => {
  //   this.setState({isAddSalary: false})
  // }
  handleUpdateSalary = payload => {
    this.props.handleSaveChange({
      rows: this.state.rows,
      salaryEmployee: payload.ListEmployeeUpdate,
      totalSalary: payload.totalSalary
    });
    this.ConfirmUpdateSalary.handleClose();
    this.SalaryEmployee.hide();
  };
  filterEmployee = async (a, b, type) => {
    // lọc ra 1 mảng nv có trong b mà không có trong a
    let afilterUsercode = a.map(function(ele) {
      return ele.userCode;
    });
    let data =
      type === "new"
        ? b.filter(e => afilterUsercode.indexOf(e.userCode) === -1)
        : b.filter(e => afilterUsercode.indexOf(e.userCode) > -1);
    return data;
  };
  openDialog = async ojb => {
    const _this = this;
    if (ojb.typeDialog === "UpdateSalary") {
      let newEmployee = [];
      let employee = this.state.rows.filter(e => e.name === "employee_salary");
      if (employee.length) {
        newEmployee = await this.filterEmployee(
          employee[0].detail,
          this.state.ListEmployeeSalary,
          "new"
        );
      }
      this.ConfirmUpdateSalary.handleClickOpen(
        newEmployee,
        this.state.ListEmployeeSalary
      );
    } else if (ojb.typeDialog === "DeleteCost") {
      this.setState(
        {
          typeDialog: ojb.typeDialog,
          itemDelete: ojb.data,
          confirmContent:
            "service_cost_are_you_sure_you_want_to_delete_this_cost"
        },
        function() {
          _this.mDialog.handleDialogOpen();
        }
      );
    }
  };
  actionDialog = () => {
    this.mDialog.handleDialogClose();
    if (this.state.typeDialog === "UpdateSalary") this.handleUpdateSalary();
    else if (this.state.typeDialog === "DeleteCost")
      this.handleDeleteCost(this.state.itemDelete);
  };
  render() {
    const { classes, t, title } = this.props;
    let totalValue = 0;

    this.state.rows.map((row, index) => (totalValue += Number(row.value)));
    let check = this.state.rows.filter(ele => ele.name === "employee_salary");
    if (!check.length && this.checkTime(this.state.month, this.state.year))
      totalValue += this.state.totalSalary; // nếu chưa có lương nv(hoặc chưa cập nhật chi phí tháng) => tổng tiền hiển thị có cộng thêm lương nv hệ thống tính
    return (
      <Paper className={classes.root}>
        <Snackbar
          color="white"
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
        <ConfirmUpdateSalary
          onRef={id => (this.ConfirmUpdateSalary = id)}
          handleUpdateSalary={this.handleUpdateSalary}
        />
        <Dialog
          onRef={dialog => (this.mDialog = dialog)}
          disagree={t("customer_listcustomer_cancel")}
          agree={t("customer_listcustomer_continute")}
          title={t("customer_listcustomer_confirm")}
          content={t(this.state.confirmContent)}
          action={this.actionDialog}
        />
        <SalaryEmployee
          onRef={id => (this.SalaryEmployee = id)}
          handleUpdateSalary={this.handleUpdateSalary}
        />
        <div>
          <Toolbar className={classes.rootToolbar}>
            <div className={classes.containerTitle}>
              <Typography
                color="inherit"
                variant="subtitle1"
                className={classes.title}
              >
                {title}
              </Typography>
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
              <Tooltip title="Action">
                <Button
                  size="medium"
                  onClick={() => this.addNewCost(true)}
                  variant="outlined"
                  color="primary"
                >
                  {t("service_cost_add_new")}
                </Button>
              </Tooltip>
            </div>
          </Toolbar>
        </div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell
                className={classes.customCell}
                align="left"
                padding="default"
                style={{ width: "60%" }}
              >
                <TableSortLabel>
                  {t("service_table_cost_cost_name")}
                </TableSortLabel>
              </TableCell>
              <TableCell
                className={classes.customCell}
                align="right"
                padding="default"
                style={{ width: "20%" }}
              >
                <TableSortLabel>
                  {t("service_table_cost_cost_value")} (
                  {this.props.setting.setting.currencyCode || "VND"})
                </TableSortLabel>
              </TableCell>
              <TableCell
                className={classes.customCell}
                align="right"
                padding="default"
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.isAddNew && (
              <TableRow>
                <TableCell align="left">
                  <TextField
                    required
                    placeholder={t("service_table_cost_cost_name")}
                    type="text"
                    className={classes.textField}
                    InputProps={{
                      classes: {
                        root: classes.customRoot,
                        input: classes.customInput
                      },
                      fullWidth: true
                    }}
                    margin="normal"
                    value={this.state.newCostName}
                    onChange={event =>
                      this.handleRowNewChange("newCostName", event.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    required
                    placeholder={t("value")}
                    type="text"
                    className={classes.textField}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                      classes: {
                        // root: classes.customRoot,
                        input: classes.customInputValue
                      },
                      fullWidth: false
                    }}
                    margin="normal"
                    value={this.state.newCostValue}
                    onChange={event =>
                      this.handleRowNewChange(
                        "newCostValue",
                        event.target.value
                      )
                    }
                  />
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleAddNewCost}
                  >
                    {t("service_table_cost_add")}
                  </Button>
                </TableCell>
              </TableRow>
            )}
            {this.state.rows.map((row, index) => {
              if (row.name !== "employee_salary")
                return (
                  <TableRow key={index}>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      className={classes.customCell}
                    >
                      {this.state.nameEdit === row.name &&
                      !this.state.isAddNew ? (
                        <TextField
                          disabled={row.isSystem ? true : false}
                          // disabled
                          placeholder={t("service_table_cost_cost_name")}
                          type="text"
                          className={classes.textField}
                          InputProps={{
                            classes: {
                              root: classes.customRoot,
                              input: classes.customInput
                            },
                            fullWidth: true
                          }}
                          margin="normal"
                          value={
                            row.isSystem
                              ? t("service_table_cost_" + row.name)
                              : row.name
                          }
                          onChange={event =>
                            this.handleRowEditChange(
                              "costName",
                              row.name,
                              event.target.value
                            )
                          }
                        />
                      ) : row.isSystem ? (
                        t("service_table_cost_" + row.name)
                      ) : (
                        row.name
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      onClick={() => this.handleEditComponent(row, index)}
                      className={classes.customCell}
                    >
                      {this.state.nameEdit === row.name &&
                      !this.state.isAddNew ? (
                        <TextField
                          required
                          // type='number'
                          className={classes.textField}
                          InputProps={{
                            classes: {
                              root: classes.customRoot,
                              input: classes.customInputValue
                            },
                            inputComponent: NumberFormatCustom,
                            fullWidth: true
                          }}
                          margin="normal"
                          value={row.value}
                          onChange={event =>
                            this.handleRowEditChange(
                              "costValue",
                              row.name,
                              event.target.value
                            )
                          }
                        />
                      ) : (
                        <NumberFormat
                          thousandSeparator={true}
                          displayType={"text"}
                          style={{ cursor: "pointer" }}
                          value={row.value}
                        />
                      )}
                    </TableCell>
                    <TableCell align="right" className={classes.customCell}>
                      {!row.isSystem ? (
                        <IconButton
                          className={classes.buttonHover + " f-right"}
                          onClick={() =>
                            this.openDialog({
                              typeDialog: "DeleteCost",
                              data: row
                            })
                          }
                          aria-label="Delete"
                        >
                          <Icon
                            className={classes.iconTrashActive + " fa fa-trash"}
                            color="inherit"
                          />
                        </IconButton>
                      ) : (
                        <IconButton
                          className={classes.buttonHover + " f-right"}
                          aria-label="Delete"
                        >
                          <Icon
                            color="inherit"
                            className={
                              classes.iconTrashNotActive + " fa fa-trash"
                            }
                          />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              else if (row.name === "employee_salary")
                return (
                  <TableRow key={index}>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      className={classes.customCell}
                    >
                      {t("service_cost_total_employee_salary")}
                      {this.checkTime(this.state.month, this.state.year) && (
                        <IconButton
                          className={classes.buttonUpdate}
                          onClick={() =>
                            this.openDialog({
                              typeDialog: "UpdateSalary",
                              data: null
                            })
                          }
                        >
                          <UpdateIcon />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell
                      align="right"
                      component="th"
                      scope="row"
                      className={classes.customCell}
                    >
                      <NumberFormat
                        thousandSeparator={true}
                        displayType={"text"}
                        value={row.value}
                      />
                    </TableCell>
                    <TableCell className={classes.customCell} align="right">
                      <IconButton
                        className={classes.buttonHover + " f-right"}
                        onClick={() => this.handleOpenSalary(row.detail)}
                        aria-label="Delete"
                      >
                        <Icon>file_copy</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
            })}
            {this.state.isAddSalary &&
              !check.length &&
              this.state.tyleList === "cost" && (
                <TableRow>
                  <TableCell align="left" className={classes.customCell}>
                    {t("service_cost_total_employee_salary")}
                    {this.checkTime(this.state.month, this.state.year) && (
                      <IconButton
                        className={classes.buttonUpdate}
                        onClick={() =>
                          this.openDialog({
                            typeDialog: "UpdateSalary",
                            data: null
                          })
                        }
                      >
                        <UpdateIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell align="right" className={classes.customCell}>
                    <NumberFormat
                      thousandSeparator={true}
                      displayType={"text"}
                      value={this.state.totalSalary}
                    />
                  </TableCell>
                  <TableCell align="right" className={classes.customCell}>
                    <IconButton
                      className={classes.buttonHover + " f-right"}
                      onClick={() =>
                        this.handleOpenSalary(this.state.ListEmployeeSalary)
                      }
                      aria-label="Delete"
                    >
                      <Icon>file_copy</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              )}

            <TableRow>
              <TableCell
                align="left"
                component="th"
                scope="row"
                className={classes.customLastRow}
              >
                <Typography variant="h6" className={classes.customHead}>
                  {t("service_cost_total_price")}
                </Typography>
                {/* totalValue */}
              </TableCell>
              <TableCell
                align="right"
                component="th"
                scope="row"
                className={classes.customCell}
              >
                <Typography variant="h6" className={classes.customHead}>
                  <PriceFormat
                    // thousandSeparator={true}
                    // displayType={"text"}
                    value={totalValue}
                  />
                </Typography>
                {/* totalValue */}
              </TableCell>
              <TableCell
                align="right"
                className={classes.customLastRow}
              ></TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {(!this.state.isAddNew && this.state.nameEdit) ||
        this.state.tyleList === "cost" ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              this.props.handleSaveChange({
                rows: this.state.rows,
                salaryEmployee: !check.length
                  ? this.state.ListEmployeeSalary
                  : "",
                totalSalary: !check.length ? this.state.totalSalary : ""
              })
            }
            className={classes.button}
          >
            {t("service_table_cost_save")}
          </Button>
        ) : (
          ""
        )}
      </Paper>
    );
  }
}

ListCost.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

const mapState = state => ({
  setting: state.setting
});

const mapDispatch = dispatch => ({
  getListEmployeeSalary: dispatch.employees.getListEmployeeSalary
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(ListCost)));
